import { useCallback } from 'react';
import { useComponentMethods } from 'js/hooks/component/useComponentMethods';

import * as server from '../server';
import * as actions from '../store/actions';
import { useDynamicReducerDispatch } from '../store';
import { JUMIO_TAG_NAME } from '../constants';

export const useGetPlayerTag = ({ t }) => {
    const dynamicReducerDispatch = useDynamicReducerDispatch();
    const { showComponentError } = useComponentMethods();

    return useCallback(async () => {
        const response = await server.getUploadRequirementTag();
        const { tags } = response.data;
        const uploadRequirementTag = tags.find((tag) => tag.name === JUMIO_TAG_NAME);

        if (!uploadRequirementTag) {
            showComponentError(t('status.disabled'));
            return;
        }

        dynamicReducerDispatch(actions.setUploadRequirement(uploadRequirementTag.value));
    }, [
        dynamicReducerDispatch,
        showComponentError,
        t
    ]);
};
